import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  NgForm,
  FormArray
} from '@angular/forms';
import { FormControl } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material';

import { AuthService } from '../_service/auth.service';
import { AlertifyService } from '../_service/alertify.service';
import { SendMailService } from '../_service/send-mail.service';
import { RequestConfirmComponent } from './request-confirm/request-confirm.component';
import { SdsRequestService } from '../_service/sdsRequest.service';

@Component({
  selector: "request",
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit {

  model = {
    id: null,
    productName: '',
    manufacturer: '',
    casNumber: '',
    productName1: '',
    manufacturer1: '',
    casNumber1: '',
    productName2: '',
    manufacturer2: '',
    casNumber2: '',
    productName3: '',
    manufacturer3: '',
    casNumber3: '',
    productName4: '',
    manufacturer4: '',
    casNumber4: '',
    fullName: '',
    email: '',
    comment: '',
    phoneNumber: '',
    healthAuthority: '',
    facility: '',
    department: ''
  };

  sdsRequestForm: FormGroup;
  manufacturer: string = '';
  productName: string = '';
  casNumber: string = '';
  fullName: string = '';
  email: string = '';
  emailSubject: string = '';
  emailBody: string = '';
  phoneNumber: string = '';
  healthAuthority: string = '';
  comment: string = '';
  facility: string = '';
  department: string = '';
  IsAccepted: number = 0;
  clicked = 0;

  index: number;
  userTopLocation: any;
  userLocationName: any = {};
  userFromCalgary: any = {};
  userLocationId: any = {};
  userLevel1Loc: any = [];
  userLevel2Loc: any = [];
  userLevel3Loc: any = [];
  userLevel4Loc: any = [];
  userLevel5Loc: any = [];

  selectedHealthAuthority;
  selectedLevel1Authority;
  selectedLevel2Authority;
  selectedLevel3Authority;
  selectedLevel4Authority;
  selectedLevel5Authority;

  topAuthHasChildren: boolean;
  level1HasChildren: any;
  level2HasChildren: any;
  level3HasChildren: any;
  level4HasChildren: any;
  level5HasChildren: any;

  isSelectedTopAuth: boolean;
  isSelectedLevel1: boolean;
  isSelectedLevel2: boolean;
  isSelectedLevel3: boolean;
  isSelectedLevel4: boolean;
  isSelectedLevel5: boolean;

  locatedAdmin: any = {};
  authorityUnitNo: any;
  restrictedAccess: any = [];

  healthAuthorityName: any;
  siteName = 'N/A';
  facilityName = 'N/A';
  departmentName = 'N/A';
  subDepartmentName = 'N/A';
  floorName = 'N/A';

  loading = false;
  emailVal: boolean;

  public form: {
    requests: Requests[];
  };

  selectedSearchParameter = 'Yes';

  requestSDS: RequestsInterface = {
    userId: null,
    id: null,
    authorityUnitId: null,
    fullName: '',
    email: '',
    comment: '',
    address: '',
    city: '',
    province: '',
    postalCode: '',
    phoneNumber: '',
    extension: '',
    isHealthCareWorker: '',
    healthAuthority: '',
    facility: '',
    site: '',
    department: '',
    subDepartment: '',
    floor: '',
    productName: '',
    productName1: '',
    productName2: '',
    productName3: '',
    productName4: '',
    casNumber: '',
    casNumber1: '',
    casNumber2: '',
    casNumber3: '',
    casNumber4: '',
    manufacturer: '',
    manufacturer1: '',
    manufacturer2: '',
    manufacturer3: '',
    manufacturer4: '',
  };

  userEmail = this.authService.decodedToken.email;
  userId = this.authService.decodedToken.nameid;

  mobile = false;
  innerWidth: any;

  constructor(
    private dialog: MatDialog,
    public fb: FormBuilder,
    public authService: AuthService,
    private alertify: AlertifyService,
    private sendMailService: SendMailService,
    private changeDet: ChangeDetectorRef,
    private sdsRequestService: SdsRequestService
  ) {
    this.form = {
      requests: []
    };

    this.sdsRequestForm = fb.group({
      productFormControl_initial: new FormControl('', [
        Validators.required,
        this.WhitespaceValidator
      ]),
      manufacturerFormControl_initial: new FormControl('', [
        Validators.required,
        this.WhitespaceValidator
      ]),
      casNoFormControl_initial: new FormControl('', []).setValidators(null),
      productFormControl_0: new FormControl('', []),
      manufacturerFormControl_0: new FormControl('', []),
      casNoFormControl_0: new FormControl('', []).setValidators(null),
      productFormControl_1: new FormControl('', []),
      manufacturerFormControl_1: new FormControl('', []),
      casNoFormControl_1: new FormControl('', []).setValidators(null),
      productFormControl_2: new FormControl('', []),
      manufacturerFormControl_2: new FormControl('', []),
      casNoFormControl_2: new FormControl('', []).setValidators(null),
      productFormControl_3: new FormControl('', []),
      manufacturerFormControl_3: new FormControl('', []),
      casNoFormControl_3: new FormControl('', []).setValidators(null),
      fullNameFormControl: new FormControl('', [
        Validators.required,
        Validators.maxLength(125),
        this.WhitespaceValidator
      ]),
      emailFormControl: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+[@]{1}[a-zA-Z0-9-.]+[.]{1}[a-zA-Z0-9]{2,3}$'),
      ]),
      regEmailFormControl: new FormControl('', []).clearValidators(),
      phoneNumberFormControl: new FormControl('', []).clearValidators(),
      extensionFormControl: new FormControl('', []).clearValidators(),

      healthAuthorityFormControl: new FormControl('', [
        Validators.required
      ]),
      siteLocationFormControl: new FormControl('', []).clearValidators(),
      facilityFormControl: new FormControl('', []).clearValidators(),
      departmentFormControl: new FormControl('', []).clearValidators(),
      subDepartmentLocationFormControl: new FormControl('', []).clearValidators(),
      floorLocationFormControl: new FormControl('', []).clearValidators(),
      commentBoxFormControl: new FormControl('', [])
    });
  }

  subjectFormControl = new FormControl('', [
    Validators.required,
  ]);

  onSelectCareWorkerConfirmation(event) {
    if (event.value === 'Yes') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === 'No') {
      this.selectedSearchParameter = event.value;
    }
  }

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  public sdsRequestValidationCheck() {
    if (this.form.requests[0] && this.form.requests[0].productName === ''
      || this.form.requests[0] && this.form.requests[0].manufacturer === '') {
      this.sdsRequestForm.controls.productFormControl_0.setValidators([Validators.required, this.WhitespaceValidator]);
      this.sdsRequestForm.controls.manufacturerFormControl_0.setValidators([Validators.required, this.WhitespaceValidator]);
      this.sdsRequestForm.controls.casNoFormControl_0.setValidators(null);

      //  this.sdsRequestForm.controls.casNoFormControl_0.setValidators([Validators.required, this.WhitespaceValidator]);
      return false;
    } else if (this.form.requests[1] && this.form.requests[1].productName === ''
      || this.form.requests[1] && this.form.requests[1].manufacturer === '') {
      this.sdsRequestForm.controls.productFormControl_1.setValidators([Validators.required, this.WhitespaceValidator]);
      this.sdsRequestForm.controls.manufacturerFormControl_1.setValidators([Validators.required, this.WhitespaceValidator]);
      this.sdsRequestForm.controls.casNoFormControl_1.setValidators(null);
      // this.sdsRequestForm.controls.casNoFormControl_1.setValidators([Validators.required, this.WhitespaceValidator]);
      return false;
    } else if (this.form.requests[2] && this.form.requests[2].productName === ''
      || this.form.requests[2] && this.form.requests[2].manufacturer === '') {
      this.sdsRequestForm.controls.productFormControl_2.setValidators([Validators.required, this.WhitespaceValidator]);
      this.sdsRequestForm.controls.manufacturerFormControl_2.setValidators([Validators.required, this.WhitespaceValidator]);
      this.sdsRequestForm.controls.casNoFormControl_2.setValidators(null);
      return false;
    } else if (this.form.requests[3] && this.form.requests[3].productName === ''
      || this.form.requests[3] && this.form.requests[3].manufacturer === '') {
      this.sdsRequestForm.controls.productFormControl_3.setValidators([Validators.required, this.WhitespaceValidator]);
      this.sdsRequestForm.controls.manufacturerFormControl_3.setValidators([Validators.required, this.WhitespaceValidator]);
      this.sdsRequestForm.controls.casNoFormControl_3.setValidators(null);
      return false;
    } else {
      this.sdsRequestForm.controls.productFormControl_initial.setValidators(null);
      this.sdsRequestForm.controls.manufacturerFormControl_initial.setValidators(null);
      this.sdsRequestForm.controls.casNoFormControl_initial.setValidators(null);

      this.sdsRequestForm.controls.productFormControl_0.setValidators(null);
      this.sdsRequestForm.controls.manufacturerFormControl_0.setValidators(null);
      this.sdsRequestForm.controls.casNoFormControl_0.setValidators(null);

      this.sdsRequestForm.controls.productFormControl_1.setValidators(null);
      this.sdsRequestForm.controls.manufacturerFormControl_1.setValidators(null);
      this.sdsRequestForm.controls.casNoFormControl_1.setValidators(null);

      this.sdsRequestForm.controls.productFormControl_2.setValidators(null);
      this.sdsRequestForm.controls.manufacturerFormControl_2.setValidators(null);
      this.sdsRequestForm.controls.casNoFormControl_2.setValidators(null);

      this.sdsRequestForm.controls.productFormControl_3.setValidators(null);
      this.sdsRequestForm.controls.manufacturerFormControl_3.setValidators(null);
      this.sdsRequestForm.controls.casNoFormControl_3.setValidators(null);

      return true;
    }
  }

  resetForm() {
    this.selectedSearchParameter = 'Yes';
    this.sdsRequestForm.get('productFormControl_initial').reset();
    this.sdsRequestForm.get('manufacturerFormControl_initial').reset();
    this.sdsRequestForm.get('casNoFormControl_initial').reset();

    this.sdsRequestForm.get('productFormControl_0').reset();
    this.sdsRequestForm.get('manufacturerFormControl_0').reset();
    this.sdsRequestForm.get('casNoFormControl_0').reset();

    this.sdsRequestForm.get('productFormControl_1').reset();
    this.sdsRequestForm.get('manufacturerFormControl_1').reset();
    this.sdsRequestForm.get('casNoFormControl_1').reset();

    this.sdsRequestForm.get('productFormControl_2').reset();
    this.sdsRequestForm.get('manufacturerFormControl_2').reset();
    this.sdsRequestForm.get('casNoFormControl_2').reset();

    this.sdsRequestForm.get('productFormControl_3').reset();
    this.sdsRequestForm.get('manufacturerFormControl_3').reset();
    this.sdsRequestForm.get('casNoFormControl_3').reset();

    this.sdsRequestForm.controls.productFormControl_initial.reset();
    this.sdsRequestForm.controls.manufacturerFormControl_initial.reset();
    this.sdsRequestForm.controls.casNoFormControl_initial.reset();

    this.sdsRequestForm.controls.productFormControl_0.reset();
    this.sdsRequestForm.controls.productFormControl_1.reset();
    this.sdsRequestForm.controls.productFormControl_2.reset();
    this.sdsRequestForm.controls.productFormControl_3.reset();

    this.sdsRequestForm.controls.manufacturerFormControl_0.reset();
    this.sdsRequestForm.controls.manufacturerFormControl_1.reset();
    this.sdsRequestForm.controls.manufacturerFormControl_2.reset();
    this.sdsRequestForm.controls.manufacturerFormControl_3.reset();

    this.sdsRequestForm.controls.casNoFormControl_0.reset();
    this.sdsRequestForm.controls.casNoFormControl_1.reset();
    this.sdsRequestForm.controls.casNoFormControl_2.reset();
    this.sdsRequestForm.controls.casNoFormControl_3.reset();


    this.form.requests = [];

    this.requestSDS.productName = '';
    this.requestSDS.manufacturer = '';
    this.requestSDS.casNumber = '';

    this.requestSDS.productName1 = '';
    this.requestSDS.manufacturer1 = '';
    this.requestSDS.casNumber1 = '';

    this.requestSDS.productName2 = '';
    this.requestSDS.manufacturer2 = '';
    this.requestSDS.casNumber2 = '';

    this.requestSDS.productName3 = '';
    this.requestSDS.manufacturer3 = '';
    this.requestSDS.casNumber3 = '';

    this.requestSDS.facility = '';
    this.requestSDS.site = '';
    this.requestSDS.department = '';
    this.requestSDS.subDepartment = '';
    this.requestSDS.floor = '';

    this.sdsRequestForm.get('fullNameFormControl').reset();
    this.sdsRequestForm.get('phoneNumberFormControl').reset();
    this.sdsRequestForm.get('extensionFormControl').reset();
    this.sdsRequestForm.get('healthAuthorityFormControl').reset();
    this.sdsRequestForm.get('facilityFormControl').reset();
    this.sdsRequestForm.get('departmentFormControl').reset();
    this.sdsRequestForm.get('subDepartmentLocationFormControl').reset();
    this.sdsRequestForm.get('floorLocationFormControl').reset();
    this.sdsRequestForm.get('commentBoxFormControl').reset();
    this.sdsRequestForm.get('emailFormControl').reset();

    this.sdsRequestForm.get('siteLocationFormControl').reset();
    this.sdsRequestForm.get('facilityFormControl').reset();
    this.sdsRequestForm.get('departmentFormControl').reset();
    this.sdsRequestForm.get('subDepartmentLocationFormControl').reset();
    this.sdsRequestForm.get('floorLocationFormControl').reset();

    this.facilityName = ''; // location
    this.siteName = ''; // department
    this.departmentName = ''; // 
    this.subDepartmentName = '';
    this.floorName = '';

    this.subjectFormControl.reset(this.selectedSearchParameter);
    this.form.requests.splice(this.index, 4);

    this.userLocationId = [];
    this.userLevel1Loc = [];
    this.userLevel2Loc = [];
    this.userLevel3Loc = [];
    this.userLevel4Loc = [];
    this.userLevel5Loc = [];
  }

  ngOnInit() {
    // detect width onload
    this.innerWidth = window.innerWidth;
    this.getLoggedInUsersEmail();
    this.userHealthAuthority();
  }

  ngAfterViewChecked() {
    // recheck width after change
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 690) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    this.sdsRequestValidationCheck();
    this.changeDet.detectChanges();
  }

  getLoggedInUsersEmail() {
    return this.authService.decodedToken.email;
  }

  isGeneric() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return false;
    }
  }

  selectedHealthAuthorityLocation(event) {
    if (event.value !== null) {
      this.isSelectedTopAuth = true;
      this.userLevel1Location();
      this.getSelectedLocationId(JSON.stringify(event.value.authorityUnitId));
      if (event.value !== null) {
        this.healthAuthorityName = event.value.locationName;
      }
      this.userLevel1Loc = [];
      this.userLevel2Loc = [];
      this.userLevel3Loc = [];
      this.userLevel4Loc = [];
      this.userLevel5Loc = [];
    }
  }

  selectedLevel1Location(event) {
    if (event.value !== null) {
      this.isSelectedLevel1 = true;
      this.userLevel2Location();
      this.getSelectedLocationId(JSON.stringify(event.value.authorityUnitId));
      if (event.value !== null) {
        this.siteName = event.value.locationName;
      }
      this.userLevel2Loc = [];
      this.userLevel3Loc = [];
      this.userLevel4Loc = [];
      this.userLevel5Loc = [];
    }
  }

  selectedLevel2Location(event) {
    if (event.value !== null) {
      this.isSelectedLevel2 = true;
      this.userLevel3Location();
      this.getSelectedLocationId(JSON.stringify(event.value.authorityUnitId));
      if (event.value !== null) {
        this.facilityName = event.value.locationName;
      }
      this.userLevel3Loc = [];
      this.userLevel4Loc = [];
      this.userLevel5Loc = [];
    }
  }

  selectedLevel3Location(event) {
    if (event.value !== null) {
      this.isSelectedLevel3 = true;
      this.userLevel4Location();
      this.getSelectedLocationId(JSON.stringify(event.value.authorityUnitId));
      if (event.value !== null) {
        this.departmentName = event.value.locationName;
      }
      this.userLevel4Loc = [];
      this.userLevel5Loc = [];
    }
  }

  selectedLevel4Location(event) {
    if (event.value !== null) {
      this.isSelectedLevel4 = true;
      this.userLevel5Location();
      this.getSelectedLocationId(JSON.stringify(event.value.authorityUnitId));
      if (event.value !== null) {
        this.subDepartmentName = event.value.locationName;
      }
      this.userLevel5Loc = [];
    }
  }

  selectedLevel5Location(event) {
    if (event.value !== null) {
      this.isSelectedLevel5 = true;
      // this.userLevel5Location();
      this.getSelectedLocationId(JSON.stringify(event.value.authorityUnitId));
      if (event.value !== null) {
        this.floorName = event.value.locationName;
      }
    }
  }

  getSelectedLocationId(id) {
    this.authorityUnitNo = id;
    return this.authorityUnitNo;
  }

  userHealthAuthority() {
    let guserId = '';
    if (this.userId == '') {
      guserId = '-1';
    } else {
      guserId = this.userId;
    }
    return this.sdsRequestService.calgaryTopHealthAuthority(guserId).subscribe(res => {
      this.userTopLocation = res;
      for (const userLocation of this.userTopLocation) {
        this.userLocationName = userLocation.locationName;
        this.userFromCalgary = userLocation.fromCalgary;
        this.userLocationId = userLocation.authorityUnitId;
      }
    });
  }

  userLevel1Location() {
    return this.sdsRequestService.getLocation(this.selectedHealthAuthority.authorityUnitId).subscribe(res => {
      this.userLevel1Loc = res;
      for (const level1LocName of this.userLevel1Loc) {
        this.level1HasChildren = level1LocName.hasChildren;
      }
    });
  }

  userLevel2Location() {
    return this.sdsRequestService.getLocation(this.selectedLevel1Authority.authorityUnitId).subscribe(res => {
      this.userLevel2Loc = res;
      for (const level2LocName of this.userLevel2Loc) {
        this.level2HasChildren = level2LocName.hasChildren;
      }
    });
  }

  userLevel3Location() {
    return this.sdsRequestService.getLocation(this.selectedLevel2Authority.authorityUnitId).subscribe(res => {
      this.userLevel3Loc = res;
      for (const level3LocName of this.userLevel3Loc) {
        this.level3HasChildren = level3LocName.hasChildren;
      }
    });
  }

  userLevel4Location() {
    return this.sdsRequestService.getLocation(this.selectedLevel3Authority.authorityUnitId).subscribe(res => {
      this.userLevel4Loc = res;
      for (const level4LocName of this.userLevel4Loc) {
        this.level4HasChildren = level4LocName.hasChildren;
      }
    });
  }

  userLevel5Location() {
    return this.sdsRequestService.getLocation(this.selectedLevel4Authority.authorityUnitId).subscribe(res => {
      this.userLevel5Loc = res;
      for (const level5LocName of this.userLevel5Loc) {
        this.level5HasChildren = level5LocName.hasChildren;
      }
    });
  }

  sdsRequest() {
    this.requestSDS.userId = this.userId;
    this.requestSDS.authorityUnitId = this.authorityUnitNo;
    this.requestSDS.fullName = this.sdsRequestForm.get('fullNameFormControl').value.trim();
    if (this.authService.decodedToken.isgeneric === 'True') {
      this.requestSDS.email = this.sdsRequestForm.get('emailFormControl').value.trim();
    } else {
      this.requestSDS.email = this.getLoggedInUsersEmail();
    }
    this.requestSDS.isHealthCareWorker = this.selectedSearchParameter;
    if (this.sdsRequestForm.controls.phoneNumberFormControl.value !== null) {
      this.requestSDS.phoneNumber = this.sdsRequestForm.get('phoneNumberFormControl').value.trim();
    } else {
      this.requestSDS.phoneNumber = '-';
    }
    if (this.sdsRequestForm.controls.extensionFormControl.value !== null) {
      this.requestSDS.extension = this.sdsRequestForm.get('extensionFormControl').value.trim();
    } else {
      this.requestSDS.extension = '-';
    }

    if (this.sdsRequestForm.controls.commentBoxFormControl.value === '') {
      this.requestSDS.comment = 'N/A';
    } else {
      this.requestSDS.comment = this.sdsRequestForm.get('commentBoxFormControl').value;
    }

    if (this.healthAuthorityName !== '') {
      this.requestSDS.healthAuthority = this.healthAuthorityName; // site
    } else {
      this.requestSDS.healthAuthority = 'N/A';
    }
    if (this.facilityName !== '') {
      this.requestSDS.facility = this.facilityName; // location
    } else {
      this.requestSDS.facility = 'N/A';
    }

    if (this.siteName !== '') {
      this.requestSDS.site = this.siteName; // department
    } else {
      this.requestSDS.site = 'N/A';
    }

    if (this.departmentName !== '') {
      this.requestSDS.department = this.departmentName; // 
    } else {
      this.requestSDS.department = 'N/A';
    }

    if (this.subDepartmentName !== '') {
      this.requestSDS.subDepartment = this.subDepartmentName;
    } else {
      this.requestSDS.subDepartment = 'N/A';
    }

    if (this.floorName !== '') {
      this.requestSDS.floor = this.floorName;
    } else {
      this.requestSDS.floor = 'N/A';
    }


    if (this.sdsRequestForm.get('productFormControl_initial') !== null) {
      this.requestSDS.productName = this.sdsRequestForm.get('productFormControl_initial').value.trim();
      this.requestSDS.manufacturer = this.sdsRequestForm.get('manufacturerFormControl_initial').value.trim();
      if (this.sdsRequestForm.controls.casNoFormControl_initial.value !== null) {
        this.requestSDS.casNumber = this.sdsRequestForm.get('casNoFormControl_initial').value.trim();
      } else {
        this.requestSDS.casNumber = 'N/A';
      }
    }
    if (this.form.requests[3] !== undefined) {
      this.requestSDS.productName4 = this.form.requests[3].productName.trim();
      this.requestSDS.manufacturer4 = this.form.requests[3].manufacturer.trim();
      if (this.form.requests[3].casNumber !== '') {
        this.requestSDS.casNumber4 = this.form.requests[3].casNumber.trim();
      } else {
        this.requestSDS.casNumber4 = 'N/A';
      }
    } else {
      this.requestSDS.productName4 = 'N/A';
      this.requestSDS.manufacturer4 = 'N/A';
      this.requestSDS.casNumber4 = 'N/A';
    }

    if (this.form.requests[0] !== undefined) {
      this.requestSDS.productName1 = this.form.requests[0].productName.trim();
      this.requestSDS.manufacturer1 = this.form.requests[0].manufacturer.trim();
      if (this.form.requests[0].casNumber !== '') {
        this.requestSDS.casNumber1 = this.form.requests[0].casNumber.trim();
      } else {
        this.requestSDS.casNumber1 = 'N/A';
      }
    } else {
      this.requestSDS.productName1 = 'N/A';
      this.requestSDS.manufacturer1 = 'N/A';
      this.requestSDS.casNumber1 = 'N/A';
    }

    if (this.form.requests[1] !== undefined) {

      this.requestSDS.productName2 = this.form.requests[1].productName.trim();
      this.requestSDS.manufacturer2 = this.form.requests[1].manufacturer.trim();
      if (this.form.requests[1].casNumber !== '') {
        this.requestSDS.casNumber2 = this.form.requests[1].casNumber.trim();
      } else {
        this.requestSDS.casNumber2 = 'N/A';
      }
    } else {
      this.requestSDS.productName2 = 'N/A';
      this.requestSDS.manufacturer2 = 'N/A';
      this.requestSDS.casNumber2 = 'N/A';
    }

    if (this.form.requests[2] !== undefined) {
      this.requestSDS.productName3 = this.form.requests[2].productName.trim();
      this.requestSDS.manufacturer3 = this.form.requests[2].manufacturer.trim();
      if (this.form.requests[2].casNumber !== '') {
        this.requestSDS.casNumber3 = this.form.requests[2].casNumber.trim();
      } else {
        this.requestSDS.casNumber3 = 'N/A';
      }
    } else {
      this.requestSDS.productName3 = 'N/A';
      this.requestSDS.manufacturer3 = 'N/A';
      this.requestSDS.casNumber3 = 'N/A';
    }

    this.loading = true;
    return this.sendMailService.sdsRequest(this.requestSDS).subscribe(
      res => {
        this.restrictedAccess = res.headers.get('restrictedaccess');
        if (this.restrictedAccess) {
          this.alertify.message(this.restrictedAccess);
          this.loading = false;
        } else {
          this.alertify.success('SDS request sent successfully');
          this.loading = false;
          this.resetForm();
        }
      },
      error => {
        this.loading = false;
        this.alertify.error('Something went wrong, please try again');
      }
    );
  }

  public addProductRequest(): void {
    this.form.requests.push({
      id: Date.now(),
      productName: '',
      manufacturer: '',
      casNumber: '',
    });
    this.changeDet.detectChanges();
  }

  submitButton() {
    this.clicked++;
    this.addProductRequest();
    this.sdsRequestValidationCheck();
    // console.log(this.form.requests);
  }

  disableButton() {
    if (this.form.requests.length === 4 && this.clicked > 3) {
      return true;
    } else {
      return false;
    }
  }

  public removeProductRequest(index: number): void {
    this.form.requests.splice(index, 1);
    this.sdsRequestForm.get(`productFormControl_${index}`).reset();
    this.sdsRequestForm.get(`manufacturerFormControl_${index}`).reset();
    this.sdsRequestForm.get(`casNoFormControl_${index}`).reset();

    this.sdsRequestForm.get(`productFormControl_${index}`).markAsPristine();
    this.sdsRequestForm.get(`manufacturerFormControl_${index}`).markAsPristine();
    this.sdsRequestForm.get(`casNoFormControl_${index}`).markAsPristine();

    this.sdsRequestForm.get(`productFormControl_${index}`).setValidators(null);
    this.sdsRequestForm.get(`manufacturerFormControl_${index}`).setValidators(null);
    this.sdsRequestForm.get(`casNoFormControl_${index}`).setValidators(null);

    this.sdsRequestForm.get(`productFormControl_${index}`).setValue('');
    this.sdsRequestForm.get(`manufacturerFormControl_${index}`).setValue('');
    this.sdsRequestForm.get(`casNoFormControl_${index}`).setValue('');

    this.sdsRequestForm.get(`productFormControl_${index}`).updateValueAndValidity();
    this.sdsRequestForm.get(`manufacturerFormControl_${index}`).updateValueAndValidity();
    this.sdsRequestForm.get(`casNoFormControl_${index}`).updateValueAndValidity();
  }

  public validation(index: number): void {
    this.sdsRequestForm.get(`productFormControl_${index}`).hasError('required');
    this.sdsRequestForm.get(`productFormControl_${index}`).hasError('whitespace');

    this.sdsRequestForm.get(`manufacturerFormControl_${index}`).hasError('required');
    this.sdsRequestForm.get(`manufacturerFormControl_${index}`).hasError('whitespace');

    this.sdsRequestForm.controls.productFormControl_0.updateValueAndValidity();
    this.sdsRequestForm.controls.manufacturerFormControl_0.updateValueAndValidity();
    this.sdsRequestForm.controls.casNoFormControl_0.updateValueAndValidity();

    this.sdsRequestForm.controls.productFormControl_1.updateValueAndValidity();
    this.sdsRequestForm.controls.manufacturerFormControl_1.updateValueAndValidity();
    this.sdsRequestForm.controls.casNoFormControl_1.updateValueAndValidity();

    this.sdsRequestForm.controls.productFormControl_2.updateValueAndValidity();
    this.sdsRequestForm.controls.manufacturerFormControl_2.updateValueAndValidity();
    this.sdsRequestForm.controls.casNoFormControl_2.updateValueAndValidity();

    this.sdsRequestForm.controls.productFormControl_3.updateValueAndValidity();
    this.sdsRequestForm.controls.manufacturerFormControl_3.updateValueAndValidity();
    this.sdsRequestForm.controls.casNoFormControl_3.updateValueAndValidity();
  }

  inputFieldValidation() {
    const fullName = this.sdsRequestForm.get('fullNameFormControl').value;
    this.authService.decodedToken.isgeneric === 'True' ?
      this.emailVal = this.sdsRequestForm.get('emailFormControl').valid : this.emailVal = this.getLoggedInUsersEmail();
    const site = this.sdsRequestForm.get('healthAuthorityFormControl').value;
    const productName = this.sdsRequestForm.get('productFormControl_initial').value;
    const manufacturerName = this.sdsRequestForm.get('manufacturerFormControl_initial').value;
    if (fullName && this.emailVal && site && productName && manufacturerName) {
      return true;
    } else {
      return false;
    }
  }

  openDiaglogRequest(form) {
    const dialogRef = this.dialog.open(RequestConfirmComponent, {
      data: {
        form: form
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(result);
    });
  }
}

interface Requests {
  id: number;
  productName: string;
  manufacturer: string;
  casNumber: string;
}


export class RequestsInterface {
  userId: null;
  id: number;
  authorityUnitId: null;
  fullName: string;
  email: string;
  comment: string;
  phoneNumber: string;
  extension: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
  healthAuthority: string;
  isHealthCareWorker: string;
  site: string;
  facility: string;
  department: string;
  subDepartment: string;
  floor: string;
  productName: string;
  productName1: string;
  productName2: string;
  productName3: string;
  productName4: string;
  casNumber: string;
  casNumber1: string;
  casNumber2: string;
  casNumber3: string;
  casNumber4: string;
  manufacturer: string;
  manufacturer1: string;
  manufacturer2: string;
  manufacturer3: string;
  manufacturer4: string;
}